export default '/build/32004fe7.svg'